<template>
  <VApp>
    <LoadingDialog ref="loading" />
    <DrawerSideBar :drawer.sync="drawer"></DrawerSideBar>
    <VToolbar v-bind:color="this.$store.state.configVisualAgendamentoOnline.corPrimaria">
      <VToolbarSideIcon :style="{ color: corDoTextoNavbar }" @click.native="drawer = !drawer"></VToolbarSideIcon>
      <span :style="{ color: corDoTextoNavbar }" v-if="this.$store.getters.sessaoAgendamentoOnline.autenticado">
        {{ "Olá, " + this.$store.getters.sessaoAgendamentoOnline.sessao.nome }}
      </span>
      <span :style="{ color: corDoTextoNavbar }" v-else>
        {{ this.$store.state.configVisualAgendamentoOnline.mensagemCustomizada }}
      </span>
      <VSpacer></VSpacer>
    </VToolbar>
    <div>
      <v-content>
        <keep-alive>
          <router-view />
        </keep-alive>
      </v-content>
    </div>
  </VApp>
</template>

<script>
import ApiService from "@/common/api.service";
import LoadingDialog from '@/components/Dialog/Loading.vue';
import * as mutations from '@/plugins/mutations.nomes';
import sessionAgendamentoOnline from "@/common/session.agendamento.online";
import { mapState } from "vuex";
import DrawerSideBar from "@/components/AgendamentoOnline/DrawerSideBar.vue";
import alerts from '@/common/alerts';
import { getTextColorBasedOnNavbarColor }  from '@/common/getTextColorBasedOnNavbarColor';

export default {
  name: 'RouterContainer',
  components: {
    LoadingDialog,
    DrawerSideBar
  },
  data: () => ({
    drawer: false,
  }),
  async mounted() {
    await this.carregarConfiguracoes();
  },
  computed: {
    ...mapState(['sessaoAgendamentoOnline', 'erro']),
    corDoTextoNavbar() {
      return getTextColorBasedOnNavbarColor(this.$store.state.configVisualAgendamentoOnline.corPrimaria);
    },
  },
  methods: {
    handler() {
      this.drawer = !this.drawer;
    },
    async carregarConfiguracoes() {
      try {
        let [parametros] = (await this.$refs.loading.aguardarPromises([ApiService.get('parametros')], 'Carregando configurações')).map(r => r.data);
        this.$store.commit(mutations.GRAVAR_PARAMETROS, parametros);
        this.$store.commit(mutations.ATUALIZAR_CONFIGURACAO, parametros.configuracoes);
        let [configVisuaisAgendamentoOnline] = (await this.$refs.loading.aguardarPromises([ApiService.get('agendamentoOnline/ObterConfiguracoesAgendamentoOnline')], 'Carregando configurações visuais')).map(r => r.data);
        if (configVisuaisAgendamentoOnline != null)
          this.$store.commit(mutations.GRAVAR_CONFIG_VISUAL_AGENDAMENTO_ONLINE, configVisuaisAgendamentoOnline);
      } catch (e) {
        alerts.exibirErro('Não foi possível carregar a configuração', e);
      }
    },
    async enviarEAguardarBackend(promises, texto) {
      return await this.$refs.loading.aguardarPromises(promises, texto);
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to) {
        this.drawer = false;
        if (to.meta.exigirLogin || (!to.meta.exigirLogin && sessionAgendamentoOnline.getSessaoAgendamentoOnline())) {
          if (!this.sessaoAgendamentoOnline.autenticado) {
            if (sessionAgendamentoOnline.getSessaoAgendamentoOnline()) {
              try {
                const requestData = {
                  Token: sessionAgendamentoOnline.getSessaoAgendamentoOnline(),
                };
                let usuario = (await ApiService.post('agendamentoOnline/sessao', requestData)).data;
                this.$store.commit(mutations.LOGIN_AGENDAMENTO_ONLINE, {
                  autenticado: true,
                  parametros: null,
                  sessao: usuario,
                });

                let [parametros] = (await this.$refs.loading.aguardarPromises([ApiService.get('parametros')], 'Carregando configurações')).map(r => r.data);
                this.$store.commit(mutations.GRAVAR_PARAMETROS, parametros);
                this.$store.commit(mutations.ATUALIZAR_CONFIGURACAO, parametros.configuracoes);

              } catch (e) {
                console.log(e);
                sessionAgendamentoOnline.setSessaoAgendamentoOnline(null);
                      await this.$router.push({name: `${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}Login`});
              }
            } else
                    await this.$router.push({name: `${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}Login`});
          }
        }
      }
    },
    drawer: {
      handler: function (value) {
        this.$nextTick(() => {
          try {
            if (value)
              document.querySelector('.v-overlay').addEventListener('click', this.handler)
            else
              document.querySelector('.v-overlay').removeEventListener('click', this.handler)
          } catch (e) {
            // error exception
          }
        })
      }
    }
  }
};
</script>

<style lang="less">
.bootstrap {
  @import (less) '~@/assets/bootstrap.min.css';
  @import (less) '~@/assets/bootstrap-theme.min.css';
}
</style>
